<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Warehouse <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Supplier Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_date.value.value"
                        :error-messages="receive_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Receive Date <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>

                      <v-date-input
                        label="Shipping Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_date.value.value"
                        :error-messages="shipping_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-textarea
                        label="Shipping Address"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_address.value.value"
                        :error-messages="shipping_address.errorMessage.value"
                        autocomplete="off"
                        rows="1"
                        clearable
                      ></v-textarea>

                      <v-text-field
                        label="Receive By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by.value.value"
                        :error-messages="receive_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="receive By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by_mobile.value.value"
                        :error-messages="receive_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="receive By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by_email.value.value"
                        :error-messages="receive_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.name}`"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <input
                        v-model="receive_masters_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col>
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="height: 40vh; overflow-y: scroll"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>
                            <th class="text-left" style="width: 25%">
                              Product Name
                            </th>
                            <th class="text-center" style="width: 15%">
                              Quantity
                            </th>
                            <th class="text-center" style="width: 15%">Unit</th>
                            <th class="text-right" style="width: 15%">Rate</th>
                            <th class="text-right" style="width: 15%">
                              Sub Total
                            </th>
                            <th class="text-center" style="width: 10%">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_name }}
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                style="width: 80px"
                                type="number"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>
                            <td class="text-right py-1">
                              {{ this.$numberFormat(item.rate) }}
                            </td>
                            <td class="text-right py-1">
                              {{ this.$numberFormat(item.total) }}
                            </td>
                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-textarea
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                              class="bg-grey-darken-1 me-2"
                              variant="flat"
                              @click="submitForm(0)"
                              >DRAFT</v-btn
                          >
                          <v-btn
                              class="bg-primary"
                              variant="flat"
                              @click="submitForm(1)"
                              >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getSupplierList.length === 0) {
      this.$store.dispatch("getSupplierList");
    }
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }
  },
  computed: {
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) =>
          item.branch_id == this.$store.getters.getAuthUser.branch_id &&
          item.status == 1
      );
    },
  },
  methods: {
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        receive_date: yup.date().required().label("Receive Date"),
        shipping_date: yup.date().nullable().label("Shipping Date"),
        supplier_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Supplier Name"),
        warehouse_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Designation Name"),
      }),
    });

    const shipping_date = useField("shipping_date");
    const product_id = useField("product_id");
    const status = useField("status");
    const employee_id = useField("employee_id");
    const supplier_id = useField("supplier_id");
    const warehouse_id = useField("warehouse_id");
    const receive_masters_id = useField("receive_masters_id");
    const receive_date = useField("receive_date");
    const remarks = useField("remarks");
    const receive_by = useField("receive_by");
    const receive_by_mobile = useField("receive_by_mobile");
    const receive_by_email = useField("receive_by_email");
    const shipping_address = useField("shipping_address"); 
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };
    
    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.receive_date = formattedDate(receive_date.value.value);
      values.shipping_date = formattedDate(shipping_date.value.value);
      store
        .dispatch("saveUpdateInvDirectReceive", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "direct-receive-records" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submit,
      submitForm,
      product_id,
      receive_date,
      shipping_date,
      remarks,
      cart,
      shipping_address,
      receive_by,
      receive_by_mobile,
      receive_by_email,
      status,
      errorMessages,
      employee_id,
      supplier_id,
      warehouse_id,
      receive_masters_id,
      buttonText,
      loading,
    };
  },

  mounted() {
    this.status.value.value = 1;
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.receive_by.value.value = user.full_name;
    this.receive_by_mobile.value.value = user.mobile;
    this.receive_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getInvDirectReceiveById", id)
          .then((data) => {
            this.isEntryMode = false;
            let receive = data;
            this.receive_masters_id.value.value = receive.id;
            this.receive_date.value.value = receive.receive_date
              ? new Date(receive.receive_date)
              : new Date();
            this.shipping_date.value.value = receive.shipping_date
              ? new Date(receive.shipping_date)
              : new Date();
            this.warehouse_id.value.value = receive.warehouse.id;
            this.supplier_id.value.value = receive.supplier.id;
            this.shipping_address.value.value = receive.shipping_address || "";
            this.product_id.value.value = null;
            this.cart.value = [];

            // Insert items one by one
            (receive.inv_dr_receive_details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_name: item.product?.name || "",
                qty: item.qty,
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                rate: item.rate,
                total: item.qty * item.rate,
              });
            });
            this.remarks.value.value = receive.remarks ? receive.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch receive:", error);
          });
      });
    } else {
      this.receive_masters_id.value.value = "";
      this.receive_date.value.value = new Date();
      this.shipping_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
